<template>
  <div>
    <header>
      <Header />
    </header>
    <div id="main">
        <section class="report">

            <div class="reportTitle">
                <div class="inner4">
                    <h1>トークショーレポート</h1><p class="titleSub">Talk Show Reports</p>
                </div><!-- /inner4-->
            </div><!-- /reportTitle-->

            <section class="reportVhead reportVhead01">
                <div class="inner4">
                    <h1><img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/title.png" srcset="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/title@2x.png 2x" alt="公式写真集＆ムック本発売記念「美しい世界との出会い」" /></h1>
                </div><!-- /inner4-->
            </section><!-- /reportVhead-->

            <div class="reportBody">

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            2022年9月16日（金）～9月19日（月・祝）、東京・渋谷ヒカリエにて「東京カメラ部2022写真展」が開催されました。開催期間中のイベントステージでは、人気フォトグラファー、写真業界関係者、歴代東京カメラ部10選などをお招きして、さまざまなテーマでトークショーが行われました。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            9月19日（月・祝）に行われた日経ナショナル ジオグラフィックのトークショーでは、東京カメラ部10選 宇賀地尚子氏、東京カメラ部10選 木村知佳氏、東京カメラ部10選 Koichi氏、東京カメラ部10選 柳楽航平氏、日経ナショナル ジオグラフィック 書籍編集長 尾崎憲和氏にご登壇いただき、「公式写真集＆ムック本発売記念『美しい世界との出会い』」というテーマでお話しいただきました。
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/01.jpg" alt="日経ナショナル ジオグラフィック 01" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            東京カメラ部運営 塚崎（司会）「みなさん、こんにちは。東京カメラ部代表の塚崎と申します。ここでは『公式写真集＆ムック本発売記念 美しい世界との出会い』というテーマで、東京カメラ部10選の宇賀地さん、木村さん、Koichiさん、柳楽さんと、日経ナショナル ジオグラフィックの尾崎さんをお迎えしてお送りしていきたいと思います。現在会場内でも販売しておりますし、書店でも販売しております。ここでは写真集に掲載されている写真や、展示作品などを紹介していきたいと思います。まずは木村知佳さん、自己紹介をお願いします」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/02.jpg" alt="日経ナショナル ジオグラフィック 02" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            木村「神戸を拠点に活動している木村知佳と申します。夜景が好きなので、今回の展示も夜景の作品を中心にしています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/03.jpg" alt="日経ナショナル ジオグラフィック 03" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            木村「鹿児島で撮影をしたロケットの光跡写真です。種子島から打ち上がったH-IIB『こうのとり』というロケットです。EOS Kiss X9とEF-S24mm F2.8 STMで撮影しました。一枚撮りに挑戦をして、6分間の露光をしました。少し無茶かな、と思ったのですが、露光が終わったときにこの写真が出てきてびっくりしました。ガッツポーズをしました」<br>
                            <br>
                            塚崎「だからこんなに星が流れているんですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/04.jpg" alt="日経ナショナル ジオグラフィック 04" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            木村「東京カメラ部10選 2021に選んでいただいた写真です。先ほどの画像を反転して遊んでみたらすごくバズってしまった一枚です。最初に10選のご連絡をいただいたときはいいのかな、と思ったのですが、リフレクションもひとつの手法ということで、今回展示させていただいています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/05.jpg" alt="日経ナショナル ジオグラフィック 05" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            木村「2021年の12月末に撮影した別のロケットの写真です。こちらは桜島で撮影しました」<br>
                            <br>
                            塚崎「最近、ロケットの光跡写真がすごく増えているんです」<br>
                            <br>
                            尾崎「そうみたいですね。ナショジオではロケット写真というか、ロケットそのものの写真があります。個人的な話ですが小さいころ桜島に住んでいたので、桜島からこんな写真が撮れるのかと感動しました」<br>
                            <br>
                            塚崎「木村さんはロケットはよく撮る被写体なんですか？」<br>
                            <br>
                            木村「これで2回目のロケットの写真になります。先ほどの写真は初挑戦で6分間の露光に大成功しました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/06.jpg" alt="日経ナショナル ジオグラフィック 06" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->

                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            木村「鹿児島の山奥で見つけた姫蛍の写真です。トータル10分くらいの露光で、比較明合成をして重ねています」<br>
                            <br>
                            塚崎「柳楽さんはこういう写真は撮るんですか？」<br>
                            <br>
                            柳楽「見たこともなくて、こんなふうになるんだなとびっくりしています。夜に光る写真が全部きれいだなと思いますね」<br>
                            <br>
                            塚崎「木村さんは光っている写真が好きなんですよね」<br>
                            <br>
                            木村「そうですね。キラキラして光っていて、動いていたら最高です」<br>
                            <br>
                            塚崎「デジタルカメラの超高感度化によって、以前に比べて夜の写真を撮りやすくなってきていますから、よかったですよね。われわれ東京カメラ部は、年間930万枚くらいの写真を投稿していただいてるのですが、夜の写真がすごく多いんですね。半分以上は夜の写真だと思います」<br>
                            <br>
                            尾崎「ナショジオにもその傾向はありますね。カメラの進化は大きいですね。この写真は光が印象的なのもいいのですが、蛍の生態まで写っているのでいいですね。夜の写真がちゃんと見えて、こうして作品になるのはとてもいいですね」<br>
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/07.jpg" alt="日経ナショナル ジオグラフィック 07" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            木村「伊丹空港で撮影した写真です。何回も通ってしまいますね。レンズはRF70-200mm F2.8 L IS USMです。飛行機が止まってくれるタイミングがあれば長時間の秒数シャッターを切れるのですが、便数が少ないと止まってくれないので、明るいレンズがあると撮れ高がすごくいいですね。EOS R5を使っていてクロップできるので、320mmくらいのところで撮っています」<br>
                            <br>
                            塚崎「この構図の写真、『伊丹が混んでいるため駐機場に飛行機が数分間駐機してくれる。だから長時間露光しても飛行機がブレずに撮れる』というのものだったと思います。しかし、今はもう混んでいなくても撮れるようになったんですね。」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/08.jpg" alt="日経ナショナル ジオグラフィック 08" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            木村「こちらは地元神戸の摩耶山から撮影した写真です。掬星台という展望台から撮りました。天気が良かったので、透明感がある写真になっていますね。星と一緒に撮りたかったので、絞らず少し開放気味で撮っているのがポイントかもしれません」<br>
                            <br>
                            尾崎「この写真でいいなと思ったのは、空を広く撮っているところです。夜景だとどうしても明かりの方を撮影してしまうんですが、星も含めた画面上の方を広くしていて、大自然の雄大さではなくて、大都会の雄大さが表現されていると思いました」<br>
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/09.jpg" alt="日経ナショナル ジオグラフィック 09" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「続いてKoichiさんお願いします」<br>
                            <br>
                            Koichi「Koichiと申します。普段は風景に人物を混ぜた写真を撮影していて、全国各地を飛び回っています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/10.jpg" alt="日経ナショナル ジオグラフィック 10" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「風景と言いつつ、いきなりこれですよ」<br>
                            <br>
                            Koichi「都内に2万発の雷が落ちた日があったんです。ここの展望台にはカメラマン専用の場所があって、腕章を付けてゆっくり撮影できるんですね。埼玉方面からすごく大きい雲がどんどん迫ってきて、ここでずっと待っていました。雷を狙って長時間露光をしています。当時、ちゃんとした望遠レンズを持っていなくて、手元にあったのは50年くらい前のロシアのオールドレンズ。逆光耐性がなかったので不安でしたが、絞り込んだらしっかりと撮れました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/11.jpg" alt="日経ナショナル ジオグラフィック 11" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「尾崎さん、この作品はナショジオに載せられますか？」<br>
                            <br>
                            尾崎「載せられるかもしれないですね。人工的な光と、自然な光が対比していますよね。でもこの下にいる人は普通に生活しているんですよね。そういうところまで含めてすごい景色だなと思いました」<br>
                            <br>
                            Koichi「この写真を撮るときにすごく緊張して、手が震えてしまいました」<br>
                            <br>
                            塚崎「写真を撮る人って、雷とか雨とかが好きですよね。僕も雪が降ると写真を撮りに出かけます。でも安全が確保できる場所で撮ってほしいなと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/12.jpg" alt="日経ナショナル ジオグラフィック 12" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            Koichi「こちらは大曲の花火大会で撮影したものです。知り合いに許可をいただいて、屋上で撮影をしました。このときは天候が悪く、すごい土砂降り状態だったんです。雨で寒くて右手が震えている状態だったので、広角レンズを地面に押し付けて、左手で右手を押さえつけて連写しました。最近のカメラはレンズとボディの手ぶれ補正がすごいので、それを最大限に活かして1秒間露光で連写しました。絶対に瞬間を逃すまいと思いながら歯でレリーズを噛んで必死に連写しました」<br>
                            <br>
                            尾崎「花火の写真はあまりナショジオでは見ないですが、最近はこういうものも見られるようになりました。非日常的というか、傘を持って花火を見るというのはなかなかない風景なので、すごくいいなと思いましたね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/13.jpg" alt="日経ナショナル ジオグラフィック 13" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                        <p>
                            Koichi「10選2020に選んでいただいたときの一枚です。上から降ってきている落ち葉は実はきれいなものを一枚ずつ拾い集めて、モデルさんに向かって投げています。10秒タイマーをセットして、何十往復もしながら撮影したものです。落ち葉の角度がすごく大事で、表を向いている状態で撮りたいというこだわりがありました。モデルさんには台の上に立っていただいて、自分はローアングルで撮影しています。富士山と被らないように、着物のシルエットの見え方にこだわりました。左から太陽の強い光が当たっています」<br>
                            <br>
                            塚崎「こういった写真はいかがですか？」<br>
                            <br>
                            尾崎「頭の中にイメージがあって、それを作り込んでいるんですね。裏側の話を聞くと改めてすごい写真なんだなと思います」
                        </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/14.jpg" alt="日経ナショナル ジオグラフィック 14" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            Koichi「新倉山浅間神社という、日本を代表する景色として海外の方にも有名な場所です。富士山と五重塔が一緒に撮れる山梨県のスポットです。桜の時期は人がたくさんいるのですが、この日は曇りで富士山が見えなかったからか、ほとんど人がいませんでした。普段観光客を乗せる馬がなにも乗せていない状態でゆっくりとこちらに向かってきたので、一緒に撮らせていただきました。よく見るとおじさんが枝のところに隠れてくれているんですよね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/15.jpg" alt="日経ナショナル ジオグラフィック 15" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「お二人の作品を含んだ、SNSで評価の高い写真を収めたのがこちらの写真集です」<br>
                            <br>
                            尾崎「皆さんにもぜひ写真家さんを応援してほしいなと思うんですよね。応援の仕方はいろいろあると思いますが、SNSでフォローするとか、コメントをするとか、こういった写真集を買うとか、そういった形で応援してほしいです」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/16.jpg" alt="日経ナショナル ジオグラフィック 16" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「そして実はもう一冊本があるんですよね」<br>
                            <br>
                            尾崎「東京カメラ部そのもののムック本を作りました。好評発売中です。今回のように、渋谷の一等地でなかなかこんな規模の写真展は開けないですよね。東京カメラ部は日本の写真のシーンを10年間作り上げてきた存在だと思いまして、ナショジオ独自の企画で制作しました。前からずっと作りたかった本で、なぜこんなことができるんだろう、という裏側の話なども含めて書いておりますので、ぜひ読んでいただきたいです」<br>
                            <br>
                            塚崎「10選の方の撮影方法や、カメラマンとして仕事をなさっている方々がどういう仕事をしているのか、プロになるまでどういう経緯だったのか、そういった話も載っています。カメラで食べていきたいという方の参考にもなるかと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/17.jpg" alt="日経ナショナル ジオグラフィック 17" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「続いて宇賀地さんお願いします」<br>
                            <br>
                            宇賀地「2014年10選の宇賀地尚子です。ポートレートを撮っています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/18.jpg" alt="日経ナショナル ジオグラフィック 18" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            宇賀地「私が撮る写真は、まず物語を書いて、それに沿った世界をビジュアル化していきます。まずぬいぐるみの絵を描いて、型紙を作って、そこから布を選んで、ぬいぐるみを作るところから始まります。世界観にあった衣装が必要になってくるんですが、なかなか既製品ではないので、Instagramで出会ったデザイナーさんに依頼して、この撮影のために作っていただきました。モデルは次女です。2014年の10選で選ばれたときもモデルは彼女でしたね。見てくださっている方は『大きくなったね』と言ってくれます」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/19.jpg" alt="日経ナショナル ジオグラフィック 19" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            宇賀地「こちらはジャイアントフラワーとスカートを作っています。合成ではなく実際に作っていて、お花は薄い紙を重ねて、スカートはすずらんテープをひたすら張り合わせて作りました。砂漠の中の花というイメージで撮っています」<br>
                            <br>
                            尾崎「アート系の作品は僕たちは普段あまり見ないのですが、宇賀地さんの作品は見ている側が勝手にストーリーを作れるというのがあると思っていて、例えば『この大きいお花は誰のところに持って行くのかな』と想像することができますよね。それが、こういう作品のいいところだなと思います」<br>
                            <br>
                            塚崎「構図からなにから全部決めて作り上げていくんですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/20.jpg" alt="日経ナショナル ジオグラフィック 20" />
                    </div><!-- /inner4-->
					<div class="exif">
						<p>
						</p>
					</div><!-- /exif-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            宇賀地「思い付いたら忘れないようにすぐイラストを描くようにしています。祖父がずっと絵を描いていたので、アトリエでずっとそういうものを見ていました」<br>
                            <br>
                            宇賀地「Alice in Pink Wonderlandという世界を作りました。ピンクが大好きなので登場人物の衣装は全部ピンクで作成しました。マッドハッターは可愛い女の子にして、娘にアリスになってもらって、帽子をたくさん作りました。下の一番大きな帽子は厚紙で、ほかはプリンカップやゼリーのカップに色々つけて作っています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/21.jpg" alt="日経ナショナル ジオグラフィック 21" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            宇賀地「こちらも次女に協力してもらった作品です。ネットで見つけたひよこの人形なのですが、すごくリアルで撮影に使いたいと思って買いました。結んだ三つ編みをテグスで引っ張っているのですが、そこにひよこを乗せると重力でぐるっと下がってしまうんですよ。何回やってもバランスが取れないので、これは写真自体を逆さまにしたら面白いかなと思い、こういった作品になりました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/22.jpg" alt="日経ナショナル ジオグラフィック 22" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            宇賀地「ポートレートと言うと若い女性というイメージがあると思うのですが、わたしはそれだけじゃないなと思っています。歳を取ってもカッコいい方々がいるんだよ、ということを伝えたくて、定期的にお願いして撮影しています」<br>
                            <br>
                            Koichi「先日昔のカメラを使っておじいちゃんを撮影しました。年配の方や身内を撮る活動もしていきたいとずっと思っています」<br>
                            <br>
                            塚崎「娘さんの成長をいろんな世界でずっと撮っていますよね。30歳、40歳になったときに振り返ると絶対に嬉しいと思うんですよね。尾崎さんは普段あまりこういった写真は見られないと思うのですが、いかがですか？」<br>
                            <br>
                            尾崎「カッコいいですし、あやとりになにかきっと意味があるに違いない、と思ってしまうんですよね。想像力を働かせて見てみるとまた面白いですよね」<br>
                            <br>
                            塚崎「衣装も素敵ですよね」<br>
                            <br>
                            宇賀地「鎌倉にいつもお世話になっている着物のお店があるのですが、いくつか見本を出してもらって、そのなかでお二人に似合うと思うものを選びました」<br>
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/23.jpg" alt="日経ナショナル ジオグラフィック 23" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「続いて柳楽さんお願いします」<br>
                            <br>
                            柳楽「柳楽航平と申します。東京カメラ部10選2021に選んでいただきました。島根県出身で、現在北海道の東の果ての方で高校教師をしています。よろしくお願いいたします」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/24.jpg" alt="日経ナショナル ジオグラフィック 24" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            柳楽「いつもシカしか勝たんと言っているのですが、シカが大好きです。エゾシカのツノの写真なのですが、光っているのがわかりますか？エゾシカのツノというと白くて立派なものを想像すると思うのですが、夏のツノはちょっと袋をかぶっているんです。皮膚なんですよね。そして産毛が生えているので、逆光になると光を吸収するんです。いつの時期にシカのツノを見ていても、美しくて花を見ているように楽しいですね」<br>
                            <br>
                            塚崎「北海道でいうと、シカはいわゆる嫌われ者。関東の方はあまり馴染みがないかもしれませんが、北海道ではシカとキツネは害獣とされています。それを美しく撮りたいと思われた理由はなんでしょうか」<br>
                            <br>
                            柳楽「初めて北海道に行ったときに、ツノが一本しかなくて痩せ細っているシカを見たんです。それでも立派に生きている姿がカッコいいなと思いました。地元の人は『シカを撮っていてなにが面白いんだ』と言うので、そういう意識を変えたいなと思っています。地元の方はいつもシカを見ているから一番目線が厳しいと思うので、そういう人たちに振り向いてもらえたら嬉しいと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/25.jpg" alt="日経ナショナル ジオグラフィック 25" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「これナショジオっぽい写真ですよね」<br>
                            <br>
                            尾崎「そうですね。シカを知らないとなかなか撮れない写真ですよね。シカのツノがいつどうなるかとか、こういうときに産毛が生えるとか。知っているから撮れるというのは動物写真家ならではですよね」<br>
                            <br>
                            塚崎「単純にきれいだからだけではなくて、知識がないと撮れない写真ということですね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/26.jpg" alt="日経ナショナル ジオグラフィック 26" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「そしてこの有名な写真です。合成写真ですか？」<br>
                            <br>
                            柳楽「よく合成写真と言われるのですが、一発撮りで頑張りました。エゾシカのツノは毎年生え変わるんです。春くらいに抜け落ちてだんだん成長していくのですが、7月になるとしっかり育ってくれるんです。満月の呼び方はいろいろあるのですが、7月はバックムーンと言って、雄鹿の月なんですよ。これは一緒に撮りたいなと思い、900mmくらいの望遠レンズで撮りました」<br>
                            <br>
                            尾崎「すごく時間をかけて撮ったんだろうなと思ったのですが、お話を聞いてびっくりしました」<br>
                            <br>
                            柳楽「パッと撮りました。いつかりこういうのを撮りたいな、という絵が頭に何パターンか入っていて、今日だな、と思ったので、パッとカメラを出してパッと撮ってパッと帰りました」<br>
                            <br>
                            塚崎「近所にシカがいるからこそ撮れる写真ですよね」<br>
                            <br>
                            柳楽「隣人のような感覚なので、『今日はあそこにいるな』と思いながら撮りました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/27.jpg" alt="日経ナショナル ジオグラフィック 27" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            柳楽「実は入り口に展示されている岐阜城の写真の設定を参考にしていて、応用して撮影しているんです。風景写真がなければこの写真は撮れなかったと思うので、感謝を申し上げたいと思います。色々な写真が見られるようになったからこそですよね。ちなみに、こちらはムック本に撮影情報が全て載っています。よろしければご覧いただきたいと思います」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/28.jpg" alt="日経ナショナル ジオグラフィック 28" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「そしてシカは美しいだけではないんですよね」<br>
                            <br>
                            柳楽「こちらは見た瞬間、美しいなとかカッコいいなと思っていただけると思うのですが、しっかり見ると悲しい写真なんです。人間の世界とエゾシカは距離が近くて、漁師さんの網や漂着した網がよく落ちているんですよね。それに一頭のエゾシカが引っかかってしまい、そこにもう一頭のエゾシカが喧嘩を仕掛けに行って、離れられない状況になっているシーンです。このあと動けなくなり、餌が採れなくて二頭とも亡くなってしまいました。僕らも助けたかったのですが、銃を撃ってはいけない場所でしたし、200キロ程度あるシカを相手にどうしようもなく見ていることしかできませんでした。エゾシカはあくまでも害獣なので、守る理由もないんですよね。ただ、漁師さんもこのあとから網を捨てるときはまとめて管理するようになったりして、人間の考え方も変わっていったのかなと思います。そういう意味で撮影してよかったと思いました」<br>
                            <br>
                            尾崎「メッセージ性がある写真だと思います。テーマが重くて、普通だったら目を背けてしまいたくなると思うのですが、写真がきれいですよね。明るくて見入ってしまいます。重たいテーマをこういった美しい写真で伝えると、メッセージがより伝わってくるのかなと思いますね」<br>
                            <br>
                            塚崎「美しさが伝える厳しさというものもあるのかもしれませんね」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/29.jpg" alt="日経ナショナル ジオグラフィック 29" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            柳楽「苦手な方は目を背けていただいた方がいいかもしれません。エゾシカはよくツノを突き合ってケンカをします。片方が負けて亡くなってしまったのですが、そのシカのツノが取れなくなってしまい、首の部分でちぎった状態の写真です。このシカはこの状態で生きていかなくてはならなくなりました。エゾシカのツノは毎年春に落ちるのですが、4月2日に見たときはまだこの状態でまるまる太っていたので、おそらくまだ無事で生き延びていると思います」<br>
                            <br>
                            塚崎「これは自然の現象ですよね」<br>
                            <br>
                            柳楽「そうですね。なので助けたいという気持ちはなくて、こういったことも皆さんが知らないところで起きているということを伝えたいと思っています」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/30.jpg" alt="日経ナショナル ジオグラフィック 30" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            柳楽「北海道の東の方には毎年2〜3月に流氷が流れてくるんです。絶対に『流氷の上には乗らないで』と言われるんです。流されて死んでしまうから。でも、エゾシカは文字が読めないですよね。これはエゾシカが間違えて流氷に乗ってしまったときの一枚です。群れでどんどん風に流されて行くなか、何頭かはすぐに飛び込んで陸に戻ったのですが、この一頭だけは飛べなくて。戻れるのか、ちゃんと泳げるのか、と心配しながら見ていたのですが、それでも頑張ってひとっ飛びして泳いで岸に帰ったときの一枚です」<br>
                            <br>
                            尾崎「すごい一枚ですね。そもそもシカって流氷の上に乗るのか、泳ぐのか？いやそんなはずないのにな、と思うじゃないですか。そうなるとこのシチュエーションはかなりシビアで、いまなにかが起きているんだろうという様子がわかりますよね。こちらの写真も明るくて美しく表現されているのがいいなと思いますね」<br>
                            <br>
                            柳楽「見てくださる方も最初は可愛いとかきれい、と言っていただけるのですが、状況がわかってくると反応がどんどん変わっていく写真ですね」<br>
                            <br>
                            塚崎「このジャンプの瞬間を捉えるのがすごいですよね」<br>
                            <br>
                            柳楽「カメラの性能が上がったからこそですね。連写をして、浮いている写真と着水している瞬間の写真があります」<br>
                            <br>
                            塚崎「どれくらい待ったんですか？」<br>
                            <br>
                            柳楽「朝に行ったらもう流されていて、一日中流されているのを見ていました。大体9時くらいに行って17時くらいまで見ていたのですが、夢中になっていたので時間が経過しているのも忘れましたね」<br>
                            <br>
                            塚崎「動物写真を撮る場合はそれくらい待つということですね。尾崎さん、ナショジオに載っている写真を撮っている方もそうなんでしょうか？」<br>
                            <br>
                            尾崎「みなさん結構待たれますね。一日二日は当たり前で、数週間、何ヶ月待ったりとか。動物写真というのはそういう世界ですね」<br>
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="photoBlock">
                    <div class="inner4">
                        <img class="" src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/31.jpg" alt="日経ナショナル ジオグラフィック 31" />
                    </div><!-- /inner4-->
                </section><!-- /photoBlock-->
				
                <section class="txtBlock">
                    <div class="inner4">
                         <p>
                            塚崎「いまお話したように、こちらのムック本には撮影したカメラの設定等も記載しておりますので、ぜひご購入ください。本日はありがとうございました」
                         </p>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->

                <section class="txtBlock">
                    <div class="inner4">
                        <div class="natgeoLinkArea">
                            <div><a href="https://natgeo.nikkeibp.co.jp/atcl/product/22/090600036/" target="_blank" rel="noopener noreferrer"><img src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/natgeo_bnr_01.jpg" alt="東京カメラ部2022写真展 公式写真集 写真との出会いは、世界との出会いだ。"></a></div>
                            <div><a href="https://natgeo.nikkeibp.co.jp/atcl/product/22/072100033/" target="_blank" rel="noopener noreferrer"><img src="https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/natgeo_bnr_02.jpg" alt="東京カメラ部ムック本 東京カメラ部 日本最大のSNS写真コミュニティー"></a></div>
                        </div>
                    </div><!-- /inner4-->
                </section><!-- /txtBlock-->
            </div><!-- /reportBody-->

        </section><!-- /report-->

    </div><!-- /main-->

    <Footer />
    <div class="actionMenu">
        <UpButton />
    </div>
  </div>
</template>
<script>
import Header from '@/components/modules/Header.vue'
import Footer from '@/components/modules/Footer.vue'
import enumMixin from '@/concern/enumMixin'
import constMixin from '@/concern/constMixin'
import UpButton from '@/components/modules/UpButton.vue'

export default {
  mixins: [enumMixin, constMixin], // Enum値, const値の読み込み
  components: {
    Header,
    Footer,
    UpButton
  },
  data () {
    return {
    }
  },
  created () {
  },
  methods: {
    setTitleAndDescription (to) {
      document.title = (to.meta.title ? to.meta.title : '')
      document.querySelector("meta[name='description']").setAttribute('content', (to.meta.desc ? to.meta.desc : ''))
    }
  },
  computed: {
  },
  mounted () {
    // titleとdescriptionの設定
    this.setTitleAndDescription(this.$route)
  },
  watch: {
    $route: function (to) {
      this.setTitleAndDescription(to)
    }
  }
}
</script>

<style scoped>
.withRightLine {
  border-right: 1px solid #000;
}
.withLeftLine {
  border-left: 1px solid #000;
}
.report .reportVhead01{
    background-image: url("https://d17sufbkz8k9co.cloudfront.net/exh2022/media/reports/natgeo/titleBk.jpg");
    background-repeat: no-repeat;
    background-position: top center;
}
.natgeoLinkArea {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    max-width: 100%;
}
.natgeoLinkArea div {
    width: 43%;
    margin-bottom: 24px;
}
@media screen and (max-width:640px){
    .natgeoLinkArea {
        display: flex;
        flex-direction: column;
        justify-content: center;
    }
    .natgeoLinkArea div {
        width: unset;
        margin: 24px 16px;
    }
}
</style>
